<template>
  <SimpleDataWithVariation
    :title="title"
    :item-id="itemId"
    :value="value"
    :variation="variation"
    :raw-variation="rawVariation"
    :request-status="requestStatus"
    :comparation-value="comparationValue"
    v-bind="$attrs"
    @reload="getData"
  />
</template>

<script>
import SimpleDataWithVariation from '@/components/cards/models/SimpleDataWithVariation';
import { mapActions } from 'vuex';
import EventBus from '@/utils/event-bus';

export default {
  name: 'CustomScoreSimpleData',
  components: {
    SimpleDataWithVariation,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      value: '',
      variation: '',
      rawVariation: '',
      highIndex: 1.2,
      lowIndex: 0.8,
      minScore: 11,
      mediumScore: 22,
      maxScore: 33,
      positive: 1,
      negative: 2,
      neutral: 3,
      noSentiment: 0,
      ratioBetweenScales: 1.5,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getWarroomService',
    ]),
    getMean(field) {
      return field.reduce((prev, next) => prev + next) / field.length;
    },
    getMeanAndNormalizeScale(scores) {
      const prevMean = this.getMean(scores);
      return (prevMean - this.maxScore) * this.ratioBetweenScales;
    },
    getPostsScores(posts, means) {
      return posts.map(post => {
        let score = 0;
        Object.entries(means).forEach(([key, value]) => {
          const valuePerMean = post[key] / value;
          if (valuePerMean > this.highIndex) {
            score += this.maxScore;
            return score;
          }
          if (valuePerMean > this.lowIndex) {
            score += this.mediumScore;
            return score;
          }
          if (valuePerMean < this.lowIndex) {
            score += this.minScore;
            return score;
          }
        });
        if (post.polarity === this.positive) {
          score += this.maxScore;
        }
        if (post.polarity === this.negative) {
          score += this.minScore;
        }
        if (post.polarity === (this.neutral || this.noSentiment)) {
          score += this.mediumScore;
        }
        return score;
      });
    },
    getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }

      this.getWarroomService({
        itemId: this.itemId,
        servicePath: 'pressPosts',
      })
        .then(response => {
          const posts = response.posts;

          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }
          this.requestStatus = 'success';
          if (posts.length === 0) {
            this.value = 0;
            return;
          }
          const means = {
            valoration: this.getMean(posts.map(post => post.valoration)),
            impact: this.getMean(posts.map(post => post.impact)),
          };
          const postsScores = this.getPostsScores(posts, means);

          this.value = this.getMeanAndNormalizeScale(postsScores);
        })
        .catch(() => {
          this.requestStatus = 'error';
        });
    },
  },
};
</script>

